import { render } from "./add.vue?vue&type=template&id=31e66f28&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=31e66f28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31e66f28"

export default script